// extracted by mini-css-extract-plugin
module.exports =  {"container":"MultiSelect-module__container___SsVIq","clearall":"MultiSelect-module__clearall___aawAG","caret":"MultiSelect-module__caret___NNnWK"};